// removed by extract-text-webpack-plugin
module.exports = {"MainContainer":"Menu__MainContainer__3Tksd"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Menu/Menu.css
// module id = 197
// module chunks = 0